import { Label } from '@/types/workflow-types';
import { apiRequest } from '@/utils/api-request';

interface UpdateLabelRequest {
  name?: string;
  description?: string | null;
  color?: string | null;
}

interface UpdateLabelResponse {
  data?: Label;
  detail?: string;
}

export async function updateLabel(
  orgId: string,
  labelId: string,
  data: UpdateLabelRequest,
): Promise<UpdateLabelResponse> {
  const response = await apiRequest<UpdateLabelResponse>({
    url: `/api/v1/orgs/${orgId}/labels/${labelId}`,
    target: 'workflow',
    method: 'PUT',
    body: data as unknown as Record<string, unknown>,
  });

  return response as UpdateLabelResponse;
}
